module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACrSURBVDiNtZFREYMwEAXfMRWABBzUAhKQEAtVgITioDhAEqAAqmD7UdJh2kACM92vZO527l4i/QugAnpgAsqjcs0vdYqYA11A9nRAviUXy8oxeqD4lt2SNZUJcGv5LM7nfpyQ70CRmdksaTj0TW9mMxuySFMrqZE0bzVcduTGzG7LO+WSXKhpb4P11M2IsQhRfIQxUCuBzzlQf0qS+RtQSbomDh7NrD26bZAXwBxA6wX7jAQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home.png
// module id = yvNz
// module chunks = 1